import { featureFlagsTracking } from "@/contexts/CdpProvider";
import { useTracking } from "@/contexts/classified";
// Import of useThorEvent is only allowed here as this is a wrapper hook
// eslint-disable-next-line no-restricted-imports
import { useThorEvent } from "@aviv-dxp/react-thor";
export const useTrackingEvent = (eventData) => {
    var _a, _b;
    const { av_client_type, av_items } = (_a = useTracking()) !== null && _a !== void 0 ? _a : {};
    const av_client_id = (_b = av_items === null || av_items === void 0 ? void 0 : av_items[0]) === null || _b === void 0 ? void 0 : _b.client_id;
    const extendedEventData = Object.assign(Object.assign({}, eventData), { av_ab_test_variant: featureFlagsTracking, av_client_type,
        av_client_id });
    return useThorEvent({
        compatibilities: { GA3: false, GA4: true },
        // @ts-ignore
        eventData: extendedEventData,
    });
};
